import { render, staticRenderFns } from "./Cardetail.vue?vue&type=template&id=2900c09c&scoped=true&"
import script from "./Cardetail.vue?vue&type=script&lang=js&"
export * from "./Cardetail.vue?vue&type=script&lang=js&"
import style0 from "./Cardetail.vue?vue&type=style&index=0&id=2900c09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900c09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
